import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

// Avatar speech functionality disabled
const initialState = {
  cs_avatar: {
    preset: {
      _id: "",
      name: "",
    },
    camera: {
      cameraPosition: JSON.stringify([0, 0, 0]),
      orbitalTarget: JSON.stringify([0, 0, 0]),
    },
    avatar: {
      url: "placeholder-avatar-url",
      type: "disabled",
      position: { x: 0, y: 0, z: 0 },
      rotate: { x: 0, y: 0, z: 0 },
      scale: 1,
      speechVoice: "disabled",
      speechText: "Avatar speech functionality has been disabled",
      welcomeText: "Avatar functionality disabled",
      background: {
        id: "disabled",
        title: "Avatar Disabled",
        author: { name: "System", url: "" },
        file: "disabled.glb",
        url: "disabled",
      },
      room: {
        position: { x: 0, y: 0, z: 0 },
        scale: 1,
        rotate: { x: 0, y: 0, z: 0 },
      },
    },
    welcomeText: "Avatar functionality disabled",
  },
};

export const avatarSpeechSlice = createSlice({
  name: "cs_avatarSpeech",
  initialState,
  reducers: {
    // All avatar speech actions disabled
    cs_addAvatarSpeech: (state, action: PayloadAction<string>) => {
      // Do nothing - functionality disabled    },
    cs_updateAvatar: (state, action: PayloadAction<any>) => {
      // Do nothing - functionality disabled    },
    cs_updateAvatarSpeechText: (state, action: PayloadAction<string>) => {
      // Do nothing - functionality disabled    },
    cs_resetAvatarSpeech: (state) => {
      // Do nothing - functionality disabled    },
  },
});

export const { 
  cs_addAvatarSpeech, 
  cs_updateAvatar, 
  cs_updateAvatarSpeechText, 
  cs_resetAvatarSpeech 
} = avatarSpeechSlice.actions;

// Export missing actions for backward compatibility
export const cs_resetAvatar = cs_resetAvatarSpeech;

export default avatarSpeechSlice.reducer;